<template>
    <div>
        <navbar1></navbar1>
        <div class="__applicationbg">
            <div class="container">
                <p class="__bepro">Web Development</p>
            </div>
        </div>
        <div class="container">
            <div class="__mtop">
                <p class="__areyou">What course do you want to offer</p>
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-3"></div>
                    <div class="col-lg-4 col-md-4 col-sm-6">
                        <select name="" id="input" class="form-control __form-control"  v-model="selectVal">
                            <option value="">Select</option>
                            <option value="frontend">Front-end Developmemt</option>
                            <option value="backend">Back-end Development</option>
                            <option value="both">Full stack</option>
                        </select>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-3"></div>
                </div>
                <!-- frontend -->
                <div  v-show="selectVal == 'frontend'">
                    <div class="row">
                        <div class="col-lg-8 col-md-8 col-sm-7">
                            <p class="__courdes">Description</p>
                            <p class="__courdes1">Front-end web development involves learning how to develop websites and applications, interact with data and convert data to graphical interface for users to view using web technologies which run on the Open Web Platform or act as compilation input for non-web platform environments. </p>
                            <p class="__courdes">What you'll learn</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; HTML5 & CSS</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; CSS Framework: Bootstrap</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; JavaScript</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp;Object Oriented Programming (OOP)</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp;Introduction to React</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; Git and Commandline</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; And finally build a complete website</p>
                            <p class="__courdes">Requirement</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; A laptop</p>
                            <p class="__courdes">Academy Location</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp;Lagos, Ibadan, Abeokuta, Port-Hacourt, Abuja</p>
                            <p class="__courdes">Learning Type</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp;ONSITE (Cohort 1 Academy Classes would ONLY Take place at our provided Facilities in Lagos)</p>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-5">
                            <div class="__coursecard">
                                <p class="__courst">Timeline</p>
                                <hr>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst1">Application Opens</p>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst2">May 24th 2020</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst1">Application Closes</p>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst3">May 24th 2020</p>
                                    </div>
                                </div>
                                <hr>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst1">Academy Starts</p>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst2">April 15th 2020</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst1">Academy Ends</p>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst3">July 19th 2020</p>
                                    </div>
                                </div>
                            </div>
                            <div class="__coursecard">
                                <p class="__courst">Class</p>
                                <hr>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst1">Starts</p>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst2">April 15th 2020</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst1">Ends</p>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst3">July 19th 2020</p>
                                    </div>
                                </div>
                            </div>
                            <div class="__coursecard">
                                <p class="__courst">Days/Time</p>
                                <hr>
                                <div class="row">
                                    <div class="col-lg-6 col-md-5 col-sm-5 col-xs-5">
                                        <p class="__courst1">Mon-Sat</p>
                                    </div>
                                    <div class="col-lg-6 col-md-7 col-sm-7 col-xs-7">
                                        <p class="__courst2">09:00am-12:00pm</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-5 col-sm-5 col-xs-5">
                                        <p class="__courst1">Sun</p>
                                    </div>
                                    <div class="col-lg-6 col-md-7 col-sm-7 col-xs-7">
                                        <p class="__courst2">12:00pm-04:00pm</p>
                                    </div>
                                </div>
                            </div>
                            <div class="__coursecard">
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst1">Price</p>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst4">150,000</p>
                                    </div>
                                </div>
                            </div>
                            <a href="https://paystack.com/pay/web-frontend-track" class="btn btn-block __applnowbtn">Apply Now!</a>
                        </div>
                    </div>
                </div>
                <!-- backend -->
                <div  v-show="selectVal == 'backend'">
                    <div class="row">
                        <div class="col-lg-8 col-md-8 col-sm-7">
                            <p class="__courdes">Description</p>
                            <p class="__courdes1">Back-end web development involves learning and understanding programming languages and server architecture, as well as a mix of databases, APIs, and operating systems that power an app’s front end.</p>
                            <p class="__courdes">What you'll learn</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; Introduction to PHP</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp;Introduction to MySQL</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; Building for PHP with AJAX</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp;  Introduction To Laravel </p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp;  Introduction to ES6</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp;  Introduction to REGEX</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp;  Introduction To Data structures with Javascript</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; Object Oriented Programming (OOP)</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; Introduction To Node.JS</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; And finally build a complete website</p>
                            <p class="__courdes">Requirement</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; A laptop</p>
                            <p class="__courdes">Academy Location</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp;Lagos, Ibadan, Abeokuta, Port-Hacourt, Abuja</p>
                            <p class="__courdes">Learning Type</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp;ONSITE (Cohort 1 Academy Classes would ONLY Take place at our provided Facilities in Lagos)</p>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-5">
                            <div class="__coursecard">
                                <p class="__courst">Timeline</p>
                                <hr>
                                <div class="row">
                                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst1">Application Opens</p>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst2">May 24th 2020</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst1">Application Closes</p>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst3">May 24th 2020</p>
                                    </div>
                                </div>
                                <hr>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst1">Academy Starts</p>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst2">April 15th 2020</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst1">Academy Ends</p>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst3">July 19th 2020</p>
                                    </div>
                                </div>
                            </div>
                            <div class="__coursecard">
                                <p class="__courst">Class</p>
                                <hr>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst1">Starts</p>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst2">April 15th 2020</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst1">Ends</p>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst3">July 19th 2020</p>
                                    </div>
                                </div>
                            </div>
                            <div class="__coursecard">
                                <p class="__courst">Days/Time</p>
                                <hr>
                                <div class="row">
                                    <div class="col-lg-6 col-md-5 col-sm-5 col-xs-5">
                                        <p class="__courst1">Mon-Sat</p>
                                    </div>
                                    <div class="col-lg-6 col-md-7 col-sm-7 col-xs-7">
                                        <p class="__courst2">09:00am-12:00pm</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-5 col-sm-5 col-xs-5">
                                        <p class="__courst1">Sun</p>
                                    </div>
                                    <div class="col-lg-6 col-md-7 col-sm-7 col-xs-7">
                                        <p class="__courst2">12:00pm-04:00pm</p>
                                    </div>
                                </div>
                            </div>
                            <div class="__coursecard">
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst1">Price</p>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst4">150,000</p>
                                    </div>
                                </div>
                            </div>
                            <a href="https://paystack.com/pay/backend-web-track" class="btn btn-block __applnowbtn">Apply Now!</a>
                        </div>
                    </div>
                </div>
                <!-- full stack -->
                <div  v-show="selectVal == 'both'">
                    <div class="row">
                        <div class="col-lg-8 col-md-8 col-sm-7">
                            <p class="__courdes">Description</p>
                            <p class="__courdes1">Full stack entails gaining functional knowledge and capability to work on all factors related to app development. That is, developing and utilizing APIs and writing backend code, writing optimized front-end code, working with system infrastructure, and understanding, creating and querying databases.</p>
                            <p class="__courdes">What you'll learn</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; HTML5 & CSS</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; CSS Framework: Bootstrap</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; JavaScript</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp;Introduction to React</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; Introduction to PHP</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp;Introduction to MySQL</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; Building for PHP with AJAX</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp;  Introduction To Laravel </p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp;  Introduction to ES6</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp;  Introduction to REGEX</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp;  Introduction To Data structures with Javascript</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; Object Oriented Programming (OOP)</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; Introduction To Node.JS</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; Git and Commandline</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; And finally build a complete website</p>
                            <p class="__courdes">Requirement</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp; A laptop</p>
                            <p class="__courdes">Academy Location</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp;Lagos, Ibadan, Abeokuta, Port-Hacourt, Abuja</p>
                            <p class="__courdes">Learning Type</p>
                            <p class="__courdes1"><span><img src="../assets/img/right-arrow.svg"></span>&nbsp;&nbsp;&nbsp;ONSITE (Cohort 1 Academy Classes would ONLY Take place at our provided Facilities in Lagos)</p>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-5">
                            <div class="__coursecard">
                                <p class="__courst">Timeline</p>
                                <hr>
                                <div class="row">
                                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst1">Application Opens</p>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst2">May 24th 2020</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst1">Application Closes</p>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst3">May 24th 2020</p>
                                    </div>
                                </div>
                                <hr>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst1">Academy Starts</p>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst2">April 15th 2020</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst1">Academy Ends</p>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst3">July 19th 2020</p>
                                    </div>
                                </div>
                            </div>
                            <div class="__coursecard">
                                <p class="__courst">Class</p>
                                <hr>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst1">Starts</p>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst2">April 15th 2020</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst1">Ends</p>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst3">July 19th 2020</p>
                                    </div>
                                </div>
                            </div>
                            <div class="__coursecard">
                                <p class="__courst">Days/Time</p>
                                <hr>
                                <div class="row">
                                    <div class="col-lg-6 col-md-5 col-sm-5 col-xs-5">
                                        <p class="__courst1">Mon-Sat</p>
                                    </div>
                                    <div class="col-lg-6 col-md-7 col-sm-7 col-xs-7">
                                        <p class="__courst2">09:00am-12:00pm</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-5 col-sm-5 col-xs-5">
                                        <p class="__courst1">Sun</p>
                                    </div>
                                    <div class="col-lg-6 col-md-7 col-sm-7 col-xs-7">
                                        <p class="__courst2">12:00pm-04:00pm</p>
                                    </div>
                                </div>
                            </div>
                            <div class="__coursecard">
                                <p class="__courst">Price</p>
                                <hr>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst1">Frontend</p>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst2">150,000</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst1">Backend</p>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst2">150,000</p>
                                    </div>
                                </div>
                                <hr>
                                <div class="row">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst1">Total</p>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                        <p class="__courst4">300,000</p>
                                    </div>
                                </div>
                            </div>
                            <a href="https://paystack.com/pay/fullstack-web-track" class="btn btn-block __applnowbtn">Apply Now!</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import navbar1 from '../components/navbar1';
    export default {
        components:{navbar1,},
        name: 'web-development',  
        data() {
                return {
                selectVal: '',
                }
            },
    }
</script>

<style scoped>
    @import '../assets/css/devstack';
</style>


// WEBPACK FOOTER //
// src/components/webdevelopment.vue